"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Combobox = void 0;
var react_1 = __importDefault(require("react"));
var ComboboxInline_1 = require("./ComboboxInline");
var ComboboxMultiselect_1 = require("./ComboboxMultiselect");
var ComboboxSingleselect_1 = require("./ComboboxSingleselect");
function Combobox(_a) {
    var inline = _a.inline, multiple = _a.multiple, props = __rest(_a, ["inline", "multiple"]);
    if (inline === true)
        return react_1.default.createElement(ComboboxInline_1.ComboboxInline, __assign({}, props));
    else if (multiple === true)
        return react_1.default.createElement(ComboboxMultiselect_1.ComboboxMultiselect, __assign({}, props));
    else
        return react_1.default.createElement(ComboboxSingleselect_1.ComboboxSingleselect, __assign({}, props));
}
exports.Combobox = Combobox;
Combobox.defaultProps = {
    loading: false,
    debounceMilliseconds: 350,
    multiple: false,
    inline: false,
};
//# sourceMappingURL=Combobox.js.map